import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { UserRoles } from "../../constants/roles";
import ChangePasswordTab from "./components/ChangePasswordTab";
import EmployeeProfileTab from "./components/EmployeeProfileTab";
import EmployeeAbsencesTab from "../absence/components/EmployeeAbsencesTab";
import EmployeeBalanceHistoryPage from "../absence/EmployeeBalanceHistoryPage";
import PageTitle from "../../components/common/PageTitle";
import TabbedPageCard from "../../components/common/TabbedPageCard";
import { UserIcon } from "../../components/common/pageIcons";
import PageLayout from "../../components/layout/PageLayout";

const EditProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const authUser = useAppSelector((state) => state.auth.user);

  const isEmployee = 
    authUser?.role === UserRoles.DISPATCHER || 
    authUser?.role === UserRoles.TRUCK_DRIVER ||
    authUser?.role === UserRoles.FLEET ||
    authUser?.role === UserRoles.SAFETY ||
    authUser?.role === UserRoles.RECRUITING ||
    authUser?.role === UserRoles.ACCOUNTING;

  if (!authUser) {
    navigate("/login");
    return null;
  }


  return (
    <PageLayout variant="fullHeight">
      <PageTitle title="Profile" icon={<UserIcon />} />
      <TabbedPageCard
        idPrefix="profile"
        ariaLabel="profile settings tabs"
        fullHeight
        panelSx={{ p: 2, height: "100%" }}
        tabs={[
          { label: "Change Password", content: <ChangePasswordTab /> },
          ...(isEmployee
            ? [
                { label: "Edit Profile", content: <EmployeeProfileTab /> },
                { label: "My Absences", content: <EmployeeAbsencesTab /> },
                {
                  label: "Absence Balance History",
                  content: <EmployeeBalanceHistoryPage />,
                },
              ]
            : []),
        ]}
      />
    </PageLayout>
  );
};

export default EditProfilePage;
